import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import TableRow from "./TableRow";

import * as agentActions from "../../store/agent";

const toFSA = (s) => s.trim().toUpperCase().replace(/\s/g, "").slice(0, 3);

const Agents = () => {
	const dispatch = useDispatch();
	const agents = useSelector((state) => state.agents);
	const [search, setSearch] = useState("");
	const [zip, setZip] = useState("");
	const [agentArr, setAgentArr] = useState([]);

	useEffect(() => {
		dispatch(agentActions.getAllAgents());
	}, [dispatch]);

	useEffect(() => {
		if (agents) {
			const fsaQuery = toFSA(zip);
			const arr = Object.values(agents)
				.filter((agent) =>
					agent?.username.toLowerCase().includes(search.toLowerCase())
				)
				.filter((agent) => {
					if (!fsaQuery) return true;
					if (agent.areas.length === 0) return false;
					return agent.areas.some((area) =>
						area.zip.toUpperCase().replace(/\s/g, "").slice(0, 3) === fsaQuery
					);
				});

			setAgentArr(arr);
		}
	}, [agents, search, zip]);

	return (
		<div className="agents-ctrl">
			<div className="agents-title">Your personal guides</div>
			<div className="agents-search">
				<div className="agents-search-wrap">
					<label>NAME</label>
					<div>
						<input
							type="text"
							value={search}
							onChange={(e) => setSearch(e.target.value)}
							placeholder="Agent Name"
						/>
						<i className="fa-solid fa-magnifying-glass"></i>
					</div>
				</div>
				<div className="agents-search-wrap">
					<label>
						SERVICE AREAS <span>POSTAL CODE (first 3)</span>
					</label>
					<div>
						<input
							type="text"
							placeholder="M5V"
							maxLength="3"
							value={zip}
							onChange={(e) => setZip(e.target.value.toUpperCase())}
						/>
						<i className="fa-solid fa-magnifying-glass"></i>
					</div>
				</div>
			</div>
			<table className="agents-table">
				<thead>
					<tr>
						<th>AGENTS</th>
						<th>SERVICE AREAS</th>
						<th>CLIENT REVIEW</th>
					</tr>
				</thead>
				<tbody>
					{agentArr.map((agent, idx) => (
						<TableRow key={"agent" + idx} agent={agent} />
					))}
				</tbody>
			</table>
		</div>
	);
};

export default Agents;
